@if (!loginConfiguration) {
  <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
} @else {
  <div class="login-form" [formGroup]="loginForm">
    <div class="login-form__header">
      <div class="login-title" i18n="@@shared.login-form.title">Login</div>
      <div class="logo-container">
        <mat-icon aria-hidden="false" aria-label="Tailormap" class="logo" svgIcon="logo"></mat-icon>
        <div class="logo-background"></div>
      </div>
    </div>

    <tm-error-message [message]="(errorMessage$ | async) ?? ''"></tm-error-message>

    @if (hasSSOButtons) {
      <div class="login-form__sso">
        <div class="section-title" i18n="@@shared.login-form.sso-title">Login with your organisation</div>
        @for (item of loginConfiguration.ssoLinks; track idx; let idx = $index) {
          @if (item.showForViewer) {
            <button mat-stroked-button
                    color="primary"
                    [tmAutoFocus]="idx === 0"
                    (click)="loginSSO(item.url)">
              @if (item.image) {
                <tm-image-with-description
                  [src]="item.image"
                  class="sso-image">
                </tm-image-with-description>
              }
              <span class="sso-button-text">
                {{item.name}}
              </span>
            </button>
          }
        }
      </div>
    }
    @if (!loginConfiguration.hideLoginForm) {
      @if (hasSSOButtons) {
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header class="login-form-panel-header">
            <mat-panel-title class="tailormap-account-title" i18n="@@shared.login-form.tm-title">Login with your Tailormap account</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngTemplateOutlet="loginFormTemplate"></ng-container>
        </mat-expansion-panel>
      } @else {
        <div class="login-form-no-sso">
          <ng-container *ngTemplateOutlet="loginFormTemplate"></ng-container>
        </div>
      }
    }

    <ng-template #loginFormTemplate>
      <div class="login-form__body" role="form">
        <div class="form-field">
          <label for="login_username" i18n="@@shared.login-form.username">Username</label>
          <input (keyup.enter)="login()"
                 [tmAutoFocus]="hasSSOButtons"
                 autocomplete="username"
                 formControlName="username"
                 id="login_username"
                 name="username"
                 type="text"/>
        </div>
        <div class="form-field">
          <label for="login_password" i18n="@@shared.login-form.password">Password</label>
          <input (keyup.enter)="login()"
                 autocomplete="current-password"
                 formControlName="password"
                 id="login_password"
                 name="password"
                 type="password"/>
        </div>
      </div>
      <div class="buttons">
        <button mat-flat-button
                name="login"
                color="primary"
                [disabled]="loginForm.invalid || (loggingIn$ | async) === true"
                (click)="login()">
          @if (loggingIn$ | async) {
            <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
          } @else {
            <ng-container i18n="@@shared.login-form.login">Login</ng-container>
          }
        </button>
      </div>

      @if (enablePasswordReset) {
        <div class="password-reset">
          <a (click)="requestPasswordResetForm()"
             i18n="@@shared.login-form.forgot-password">Forgot your password?</a>
        </div>
      }
    </ng-template>

  </div>
}
